import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IAgencyUser } from '../interfaces/agency-user';
import { IAddAgencyUser } from '../interfaces/add-agency-user';
import { IAddNewAgencyUser } from '../interfaces/add-new-agency-user';
import { IUpdateAgencyUser } from '../interfaces/update-agency-user';

@Injectable({
  providedIn: 'root'
})
export class AgencyUserService {
  private rootUrl: string = "/api/agency-users";

  constructor(private httpClient: HttpClient) { }

  public getAgencyUsers(appId: number, agencyId: number): Observable<IAgencyUser[]> {
    const url = this.rootUrl + "?appId=" + appId + "&agencyId=" + agencyId;
    return this.httpClient.get<IAgencyUser[]>(url);
  }

  public addAgencyUser(appId: number, agencyId: number, addAgencyUser: IAddNewAgencyUser): Observable<string> {
    const url = this.rootUrl + "?appId=" + appId + "&agencyId=" + agencyId;
    return this.httpClient.post<string>(url, addAgencyUser);
  }

  public addAgencyUserFromExisting(appId: number, agencyId: number, addAgencyUser: IAddAgencyUser) {
    const url = this.rootUrl + "/from-existing?appId=" + appId + "&agencyId=" + agencyId;
    return this.httpClient.post(url, addAgencyUser);
  }

  public updateAgencyUser(id: string, appId: number, updateAgencyUser: IUpdateAgencyUser) {
    const url = this.rootUrl + "/" + id + "?appId=" + appId;
    return this.httpClient.put(url, updateAgencyUser);
  }

  public removeAgencyUser(appId: number, agencyId: number, id: string) {
    const url = this.rootUrl + "/" + id + "?appId=" + appId + "&agencyId=" + agencyId;
    return this.httpClient.delete(url);
  }
}
